module.exports = __webpack_public_path__ + "img/xp_icon_yf05.png";